import {protectedWhatsAppFetch} from "./protectedWhatsApp";

export async function sendWhatsAppVPS(
  clinicId,
  phone,
  message,
  patientId = null,
  patientName = null
) {

  try {

    const controller =
      new AbortController();

    const timeout =
      setTimeout(() => {

        controller.abort();

      }, 30000);

    const response = await protectedWhatsAppFetch(
      "https://wa.vexadent.com/send-message",
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json"
        },

        body: JSON.stringify({

          clinicId,

          phone,

          message,

          patientId,

          patientName

        }),

        signal:
          controller.signal

      }
    );

    clearTimeout(
      timeout
    );

    let data = {};

    try {

      data =
        await response.json();

    } catch {

      data = {};

    }

    return {

      ...data,

      success:
        response.ok &&
        data.success !== false

    };

  } catch (error) {

    return {

      success: false,

      error:
        error.name === "AbortError"
          ?
          "El envío del mensaje tardó demasiado."
          :
          error.message

    };

  }

}

export async function sendWhatsAppFileVPS(
  clinicId,
  phone,
  fileUrl,
  filename,
  caption = "",
  mimeType = ""
) {

  return await sendWhatsAppRequest(
    "/send-file",
    {
      clinicId,
      phone,
      fileUrl,
      filename,
      caption,
      mimeType
    }
  );

}

async function sendWhatsAppRequest(
  endpoint,
  payload
) {

  try {

    const controller =
      new AbortController();

    const timeout =
      setTimeout(() => {

        controller.abort();

      }, 60000);

    const response = await protectedWhatsAppFetch(

      `https://wa.vexadent.com${endpoint}`,

      {

        method: "POST",

        headers: {

          "Content-Type":
            "application/json"

        },

        body:
          JSON.stringify(
            payload
          ),

        signal:
          controller.signal

      }

    );

    clearTimeout(
      timeout
    );

    let data = {};

    try {

      data =
        await response.json();

    } catch {

      data = {};

    }

    return {

      ...data,

      success:
        response.ok &&
        data.success !== false

    };

  } catch(error) {

    return {

      success: false,

      error:
        error.name === "AbortError"
          ?
          "El envío del archivo tardó demasiado."
          :
          error.message

    };

  }

}

export async function sendFileToWhatsApp({

  clinicId,

  phone,

  file,

  caption = "",

  conversationId,

  patientId,

  db,

  storage,

  collection,

  addDoc,

  ref,

  uploadBytes,

  getDownloadURL

}) {

  const extension =
    file.name
      .split(".")
      .pop();

  const fileName =
    `${Date.now()}.${extension}`;

  const storageRef =
    ref(

      storage,

      `clinics/${clinicId}/whatsappFiles/${fileName}`

    );

  await uploadBytes(
    storageRef,
    file
  );

  const downloadURL =
    await getDownloadURL(
      storageRef
    );

  try {

    const result =
      await sendWhatsAppFileVPS(

        clinicId,

        phone,

        downloadURL,

        file.name,

        caption,

        file.type

      );

    if (
      !result?.success
    ) {

      throw new Error(

        result?.error ||
        "No se pudo enviar el archivo por WhatsApp."

      );

    }

    // Fallback local: mantiene el mensaje visible aunque el servidor todavía
    // no haya sido reiniciado con el listener de media actualizado.
    const fileDoc = await addDoc(
      collection(
        db,
        "clinics",
        clinicId,
        "whatsappConversations",
        conversationId,
        "messages"
      ),
      {
        type: file.type?.startsWith("image/")
          ? "image"
          : file.type?.startsWith("video/")
            ? "video"
            : file.type?.startsWith("audio/")
              ? "audio"
              : "document",
        filename: file.name,
        mimeType: file.type,
        fileUrl: downloadURL,
        fileSize: file.size,
        caption,
        body: caption,
        fromMe: true,
        status: "sent",
        timestamp: new Date()
      }
    );

    if (patientId) {

      await addDoc(

        collection(
          db,
          "clinics",
          clinicId,
          "pacientes",
          patientId,
          "files"
        ),

        {

          filename:
            file.name,

          mimeType:
            file.type,

          fileUrl:
            downloadURL,

          fileSize:
            file.size,

          source:
            "vexadent",

          fromMe:
            true,

          createdAt:
            new Date()

        }

      );

    }

    return {

      result,

      downloadURL,

      fileDoc

    };

  } catch (error) {

    return {

      result: {

        success: false,

        error:
          error?.message ||
          "No se pudo enviar el archivo por WhatsApp."

      },

      downloadURL,

      fileDoc:
        null

    };

  }

}
